export const VERSION = 'v1/'
export const API_BASE_URL = process.env.API_APP_URL + VERSION
export const CDB_JWT_ACCESS_TOKEN = 'CDBSyncAccessJwtToken'
export const BASIC_AUTH_SPREADSHEET = 'BasicAuth.Spreadsheet'
export const BASIC_AUTH_CUSTOM_ITEM = 'BasicAuth.CustomItem'
export const CHECK_RELOAD = 'CheckReload'
export const CHECK_ERROR = 'CheckError'

export const ERROR_SYSTEM = '要求が失敗しました。 後でお試しください ！'
export const RC_HTTP_200 = 200
export const RC_HTTP_400 = 400
export const RC_HTTP_401 = 401
export const RC_HTTP_403 = 403
export const RC_HTTP_404 = 404
export const RC_HTTP_422 = 422
export const RC_HTTP_500 = 500

export const AA_ACCOUNT_TYPE = 'AA'
export const ERROR = 'error'
export const SUCCESS = 'success'

export const CUSTOM_PERIOD = -4

export const ACTIVE = 1
export const VISIT_OS_ONE = { id: 1, text: '訪問' }
export const VISIT_OS_TWO = { id: 2, text: 'OS' }

export const CLASSIFICATION_MARKETING_ID = 1
export const APPOINTMENT_CHANNEL_SONOTA = 'その他'
export const LINE_COLOR_MEETING = {
  one: 'A',
  two: 'B',
  three: 'C',
  four: '受注'
}
export const PROPOSAL_PRODUECTS = [
  '',
  '営業支援',
  '営業の型化',
  'セールス・アカデミー',
  'セールス・インソーシング',
  'セールス・クラウド',
  '在宅構築支援',
  'ママワークス（掲載）',
  'ママワークス（インクルード分）',
  'meet in（単体利用）',
  'meet in（代理店）',
  'BIZMAPS（データ販売）',
  'BIZMAPS（トップアプローチ）',
  'BIZMAPS（リストプラス）',
  'BIZMAPS（フォームアプローチ）',
  'クラプロ',
  'リワークス',
  'キーパーソンズ',
  'CXOバンク',
  'IPO支援サービス',
  '管理支援',
  'リモワマッチング',
  'テストワーク',
  'OEM',
  'SES',
  '広報支援',
  'クラウド・エージェンシー',
  'メイクブイ',
  'アッドラスト',
  'エンターナビ',
  '決裁者マーケティング',
  'キーパーソンズ（マッチング）',
  'その他'
]
export const INDUSTRY_ONE = { id: 1, text: '大業種' }
export const INDUSTRY_TWO = { id: 2, text: '中業種' }
export const UNIT_SYMBOL = {
  yen: '\xa5'
}
export const CONSISTENCY_CHECK = ['問題なし', '確認できず', '問題あり']
export const CM_JUDGMENTS = ['CM規定内', 'CM規定外']
export const JUDGMENTS = ['規定内', '規定外']
export const INSUFFICIENT_APPOINTMENTS = ['有', '無', '音声無']
export const LOG_RANKS = ['A', 'B', 'C', 'D', 'E']
export const CHANNELS = [
  '',
  'チャネル',
  'Tel',
  'トス（MAツール）',
  'SalesCrowd',
  'セールス・プラットフォーム',
  'オンラインセールスラボ',
  'CXOバンク',
  'BIZ通常アプ',
  'BIZ会員アプ',
  'アッドラスト',
  'FAX',
  'DM',
  '手紙',
  'フォーム',
  'メルマガ',
  '展示会',
  'ウェビナー',
  'SNS',
  'webマーケ(コーポレートサイト問い合わせ)',
  'webマーケ(資料DL)',
  'webマーケ(一括)',
  'webマーケ(facebook広告)',
  'webマーケ(まーけっち)',
  'リードナーチャリング',
  'トス(マネージャー)',
  'トス（ママワークス）'
]
export const CLAIMED_COMPANY_NAMES = [
  '',
  'アイドマ・ホールディングス',
  'セールス・プラットフォーム',
  'セールスクラウド',
  'オンラインセールスラボ',
  'CXOバンク',
  'BIZMAPS',
  'アッドラスト',
  'マーケメディア',
  'ウリカタ',
  'ミートイン',
  'リワークス',
  'クラプロ',
  '音声無しのため不明',
  '社名の名乗り無し'
]
export const CANCELLATION_REASONS = [
  'セールス・アカデミー（データ販売）',
  '多忙・急用（当日のみ調整可）',
  '多忙・急用（直近1ヶ月以内調整OK）',
  '多忙・急用（直近調整NG）',
  '連絡が付かない',
  'アポ認識なし',
  '興味がない',
  '商材が合わない',
  'タイミングNG',
  'CMトス(対象外)',
  'CPトス失敗（過去FC、CMトスも不可）',
  'ヒアリング不可（規定外）',
  'リスケ提案拒否',
  'リスケ不可（Fアポ当日反映不可）',
  'SL/CM対象外（リスケ失敗）',
  'メール返信（リスケ希望）',
  'メール返信（急用・多忙）',
  'メール返信（体調不良）',
  'メール返信（不要）',
  'メール返信（不明）',
  '金額NG',
  '事業縮小検討･拡大意識なし',
  'オンライン商談不可',
  'BtoCのみ',
  'SL供給不可',
  '上申NG',
  '直近商談先',
  '現クライアント',
  'アポNG業種（パチンコ運営/風俗関係/占い/宗教）',
  '与信NG（過去犯罪履歴、裁判履歴あり）',
  'アポ重複',
  'その他の理由',
  'Eランクアポ',
  'コミュニケーションNG'
]
export const LOG_RANK_CLASSIFICATIONS = [
  'A：通常アポ／日程認識あり',
  'B：通常アポ／「先方から」事前連絡してほしいと伝達あり',
  'B：通常アポ／「架電者から」事前連絡しますと伝えている',
  'B：仮アポ／仮アポ打診はしているが、先方はっきりと日時了承している',
  'B：仮アポ／仮アポで打診後、本人が日時指定して取得',
  'C：仮アポ／先方興味あるが、同席者調整のために仮アポ（代表日程は抑えている）',
  'C：仮アポ／日時流動的、事前連絡で確定ならOKと仮押さえの認識はある',
  'C：仮アポ／仮アポは一旦OKだが、資料の内容によっても判断したい',
  'C：仮アポ／仮押さえ日時を「はっきりと」承諾を得たうえで、候補日記載をお伝えしたアポ取得',
  'D：アポ認識微妙／先方あしらい程度に返事しているだけのアポ',
  'D：アポ認識微妙／かなり強引に話を進めており承諾得ているか微妙なアポ',
  'E：アポではない／一方的に日程打診「承諾得ないまま」アポ登録（～でよろしいでしょうか？という聞き方できていない、など）',
  'E：アポではない／ただの日程候補メール送信打診（●日中心に～／仮押さえも伝えているだけ）',
  'E：アポではない／オンライン商談の認識なく、ただ電話or資料が来るだけの認識系',
  'E：アポではない／当日連絡し、いればそのまま話を聞いてください系',
  'E：アポではない／明確なアポ日時が決まっていない（今ぐらいの時間で～と打診のまま終話）',
  'E：アポではない／日程調整後「やっぱいい」など途中で切電されている',
  'E：アポではない／先方担当者と直接話さずに日程調整している',
  'E：アポではない／その他アポと認められない可能性高いもの'
]



// WEBPACK FOOTER //
// ./src/common/constants.js